/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../common";
import type { Staking, StakingInterface } from "../../contracts/Staking";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "AddressEmptyCode",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "AddressInsufficientBalance",
    type: "error",
  },
  {
    inputs: [],
    name: "FailedInnerCall",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "a",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "b",
        type: "uint256",
      },
    ],
    name: "Lock_BalanceOverflow",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "a",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "b",
        type: "uint256",
      },
    ],
    name: "Lock_BalanceUnderflow",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
    ],
    name: "Lock_InactiveStake",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "neededAmount",
        type: "uint256",
      },
    ],
    name: "Lock_InsufficientBalance",
    type: "error",
  },
  {
    inputs: [],
    name: "Lock_InvalidToken",
    type: "error",
  },
  {
    inputs: [],
    name: "Lock_NativeTransferFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "ReentrancyGuardReentrantCall",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "SafeCastOverflowedUintToInt",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "SafeERC20FailedOperation",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "amount",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "StakeChanged",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "getLockAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "getStakeData",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "activeFrom",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "staker",
            type: "address",
          },
          {
            internalType: "contract IERC20",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct ILock.StakeData",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "lock",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "totalStaked",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "unlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type StakingConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: StakingConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Staking__factory extends ContractFactory {
  constructor(...args: StakingConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      Staking & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): Staking__factory {
    return super.connect(runner) as Staking__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): StakingInterface {
    return new Interface(_abi) as StakingInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): Staking {
    return new Contract(address, _abi, runner) as unknown as Staking;
  }
}
